var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "div",
      {
        staticClass: "d-block",
      },
      [
        _c(
          "div",
          {
            staticClass: "card-body ma-0 pa-0",
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-white",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "d-flex text-lg py-1 px-1 border-top",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "w-50 border-right",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-center text-lg text-monospace text-success",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  Intl.NumberFormat("en-US").format(
                                    _vm.transaction.ticketNumber.reduce(
                                      function (sum, number) {
                                        return sum + number.amount
                                      },
                                      0
                                    )
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "w-50",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-center text-lg text-monospace text-danger",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  Intl.NumberFormat("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(
                                    _vm.transaction.ticketNumber.reduce(
                                      function (sum, number) {
                                        return sum + number.win_amount
                                      },
                                      0
                                    )
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.transaction.constants, function (constant, slug_name) {
              return _c(
                "div",
                {
                  key: slug_name,
                },
                [
                  _vm.transaction.ticketNumber.filter(function (number) {
                    return number.slug == slug_name
                  }).length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "text-xl bg-yellow text-black text-left py-2 px-2 mb-0",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(constant) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(1, true),
                          _vm._v(" "),
                          _vm._l(
                            _vm.transaction.ticketNumber.filter(function (
                              number
                            ) {
                              return number.slug == slug_name
                            }),
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  class: _vm.changeColor(item.win_amount),
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex text-lg py-1 border-top",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "w-20x border-right",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-md",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.digits) +
                                                  "\n                  "
                                              ),
                                              slug_name != "4upper"
                                                ? _c("span", [
                                                    _c("i", {
                                                      class:
                                                        _vm.iconType(slug_name),
                                                    }),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "border-right",
                                          staticStyle: {
                                            width: "16%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-md",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    item.result
                                                      ? item.result
                                                      : "-"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "border-right",
                                          staticStyle: {
                                            width: "18%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-md",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    Intl.NumberFormat(
                                                      "en-US"
                                                    ).format(item.amount)
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "w-20x border-right",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-md",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    Intl.NumberFormat(
                                                      "en-US"
                                                    ).format(item.prize_rate)
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "26%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-md",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    Intl.NumberFormat("en-US", {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    }).format(
                                                      item.win_amount > 0
                                                        ? item.win_amount
                                                        : 0
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "bg-danger text-white",
      },
      [
        _c(
          "div",
          {
            staticClass: "d-flex text-lg py-1 px-1 border-top",
          },
          [
            _c(
              "div",
              {
                staticClass: "w-50 border-right",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text-center text-lg text-monospace",
                  },
                  [_vm._v("\n              ยอดแทงรวม\n            ")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-50",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text-center text-lg text-monospace",
                  },
                  [_vm._v("\n              ยอดถูกรวม\n            ")]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass:
          "d-flex text-md font-weight-bold py-1 border-top bg-black text-white",
      },
      [
        _c(
          "div",
          {
            staticClass: "w-20x text-center border-right",
          },
          [
            _c(
              "div",
              {
                staticClass: "text-monospace",
              },
              [_vm._v("\n                แทง\n              ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-center border-right",
            staticStyle: {
              width: "16%",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "text-monospace",
              },
              [_vm._v("\n                รางวัล\n              ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-center border-right",
            staticStyle: {
              width: "18%",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "text-monospace",
              },
              [_vm._v("\n                ยอดแทง\n              ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "w-20x text-center border-right",
          },
          [
            _c(
              "div",
              {
                staticClass: "text-monospace",
              },
              [_vm._v("\n                จ่าย\n              ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-center",
            staticStyle: {
              width: "26%",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "text-monospace",
              },
              [_vm._v("\n                ยอดถูก\n              ")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }